import React from "react";
import { Form, Layout, PageWrap } from "@vwfs-bronson/bronson-react";
import { VehicleCondition } from "../components/question-1/VehicleCondition";
import { VehicleModels } from "../components/question-1/VehicleModels";
import { VehicleFuelType } from "../components/question-1/VehicleFuelType";
import { WizardButtons } from "../components/ui/WizardButtons";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMatchMakerWizard } from "../hooks/useMatchMakerWizard";
import { useTranslation } from "react-i18next";
import { IMatchMakerAnswers, Step, SubmitAnswersRequest } from "../interfaces";
import { FocusError } from "../components/generic/FocusError";
import { SaveAndContinue } from "../components/save-and-continue/SaveAndContinue";

export const Question1Page = () => {
    const { t } = useTranslation("errormessages");
    const { submitAnswersRequest, setSubmitAnswersRequest, isEdit } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;

    const SignupSchema = Yup.object().shape({
        conditions: Yup.array().of(Yup.string()).min(1, t("errormessages:0")).required(t("errormessages:0")),
        models: Yup.array()
            .of(Yup.string())
            .min(1, t("errormessages:0"))
            .max(3, t("errormessages:00"))
            .required(t("errormessages:0")),
        fuelTypes: Yup.array()
            .of(Yup.string())
            .min(1, t("errormessages:0"))
            .max(2, t("errormessages:00"))
            .required(t("errormessages:0")),
    });

    return (
        <>
            <Formik
                initialValues={{
                    conditions: matchMakerAnswers?.conditions ?? undefined,
                    models: matchMakerAnswers?.models ?? undefined,
                    fuelTypes: matchMakerAnswers?.fuelTypes ?? undefined,
                }}
                validationSchema={SignupSchema}
                enableReinitialize={true}
                onSubmit={(values: IMatchMakerAnswers | undefined) => {
                    setSubmitAnswersRequest((value) => {
                        return {
                            ...value,
                            matchMakerAnswers: {
                                ...matchMakerAnswers,
                                ...values,
                            },
                            isEditMode: isEdit,
                            currentStep: Step.MM1,
                        } as SubmitAnswersRequest;
                    });
                }}
            >
                {(formikProps: { handleSubmit: React.FormEventHandler<HTMLFormElement> | undefined; }) => (
                    <Form id="Question1PageForm" onSubmit={formikProps.handleSubmit} noValidate>
                        <Layout className="u-mt-xsmall" flush>
                            <Layout.Item>
                                <PageWrap size="small">
                                    <VehicleCondition />
                                    <hr className="u-mv-large" />
                                    <VehicleModels />
                                    <hr className="u-mv-large" />
                                    <VehicleFuelType />
                                    <FocusError />
                                </PageWrap>
                            </Layout.Item>
                            <Layout.Item className="u-mt">
                                <WizardButtons />
                            </Layout.Item>
                        </Layout>
                    </Form>
                )}
            </Formik>
            <SaveAndContinue />
        </>
    );
};
